<template>
  <b-container class="mt-5">
    <b-row>
      <b-col cols="6" offset="3">
        <Logo :logoProps="logo" class="mb-5" />
        <b-alert show variant="warning" v-if="error">
          <h4 class="alert-heading">Error!!!</h4>
          <p>Oops!!!!, it appears that your username and password are not valid, please try again or contact support</p>
        </b-alert>
        <b-alert show variant="success" v-if="success">
          <h4 class="alert-heading">Success</h4>
          <p>Oops!!!!, it appears that your username and password are not valid, please try again or contact support</p>
        </b-alert>
        <h4>Forgot Password</h4>
        <b-form class="text-left mt-5">
          <b-form-group label="Username" label-cols-sm="4" label-cols-lg="3" label-for="username">
            <b-form-input
              type="email"
              v-model="$v.form.username.$model"
              placeholder="eg. username@ethixbase.com"
              :state="$v.form.username.$dirty ? !$v.form.username.$error : null"
            />
            <div v-show="submitted && !form.username" class="invalid-feedback">Username is required</div>
          </b-form-group>
          <b-form-group class="float-right">
            <b-button class="mx-2" to="/" variant="outline-primary">Back</b-button>
            <b-button
              @click="onSubmit"
              :disabled="$v.form.$invalid"
              variant="outline-primary"
            >Reset Password</b-button>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Logo from "../../components/logo/logo.vue";
import { Helper } from "../../helpers";
export default {
  name: "EmployeeForgotPassword",
  mixins: [validationMixin],
  components: {
    Logo,
  },
  data() {
    return {
      logo: {
        width: "auto",
        height: "50px",
        class: "mt-2",
      },
      form: {
        username: null,
      },
      error: false,
      success: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      username: {
        required,
        minLength: minLength(5),
      },
    },
  },
  methods: {
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else {
        this.forgotPasswordApiCall();
      }
    },
    makeToster(tosterVarient, tosterMsg) {
      Helper.makeToast(this.$bvToast, tosterVarient, tosterMsg);
    },
    async forgotPasswordApiCall() {
      let formData = {
        username: this.form.username,
      };
      try {
        let result = await HTTP("post", "forgot/password/eb2", formData);
        if (result.data.status == 0) {
          this.makeToster("danger", result.data.message);
        } else if (result.data.status == 1) {
          this.makeToster("danger", result.data.message);
        } else if (result.data.status == 2) {
          this.makeToster("success", result.data.message);
        }
        this.$v.$reset();
      } catch (err) {
        return [err];
      }
    },
    alerts() {
      if (this.form.username != "") {
        this.success = true;
      } else {
        this.error = true;
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
</style>

